import { render } from "./jl4Echarts.vue?vue&type=template&id=1ad736c0&scoped=true"
import script from "./jl4Echarts.vue?vue&type=script&lang=js"
export * from "./jl4Echarts.vue?vue&type=script&lang=js"

import "./jl4Echarts.vue?vue&type=style&index=0&id=1ad736c0&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad736c0"]])

export default __exports__